import React from 'react'
import LoadingIndicator from 'components/LoadingIndicator';
import './AskVisoThinking.scss'

const AskVisoThinking = ({ color }) => {
  return (
    <div className='ask-viso-thinking'>
      <LoadingIndicator color={color} scrollClass='ask-viso-thinking__scroll' />
    </div>
  )
}

export default AskVisoThinking